// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__-HeyW","checkboxCol":"Table_checkboxCol__3J5oR","emailCol":"Table_emailCol__mrCpP","actionCol":"Table_actionCol__2Q2Pd"};